import mutations from './room.mutations'
import actions from './room.actions'
import getters from './room.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
